import React from 'react';
import './Cards.css';
import CardItemModel from './CardItemModel.js';


function Model() {
  return (
    <div className='cards'>
      
      <h1>Models</h1>
      <p className="heading p__color">
        Build This models on Your Land!!
      </p>
      <div className='cards__container'>
      <div className='cards__items'>
            <CardItemModel
              src='images/BAM 26/BAM 26 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 26'
              path='/bam26'
              price='LKR 7.2 Million'
              description='3 Bedrooms,2 Bathroom'
            />
            </div>

      <div className='cards__items'>
            <CardItemModel
              src='images/BAM 27/BAM 27 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 27'
              path='/bam27'
              price='LKR 25 Million'
              description='6 Bedrooms,02 Bathroom'
            />
            </div>

      <div className='cards__items'>
            <CardItemModel
              src='images/BAM 28/BAM 28 (13).jpg'
              text='THREE STORY HOUSE'
              label='BAM 28'
              path='/bam28'
              price='LKR 43.5 Million'
              description='09 Bedrooms,04 Bathroom'
            />
            </div>

      <div className='cards__items'>
            <CardItemModel
              src='images/BAM 29/BAM 29 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 29'
              path='/bam29'
              price='LKR 25 Million'
              description='6 Bedrooms,2 Bathroom'
            />
            </div>

      <div className='cards__items'>
            <CardItemModel
              src='images/BAM 30/2.jpg'
              text='Landscaping Model'
              label='BAM 30'
              path='/bam30'
              price='According To work'
              description='Modification of Your land'
            />
            </div>
          <div className='cards__items'>
            <CardItemModel
              src='images/BAM 31/BAM 31 (1).jpg'
              text='SINGLE STORY HOUSE'
              label='BAM 31'
              path='/bam31'
              price='LKR 7.2 Million'
              description='4 Bedrooms,2 Bathroom'
            />
            </div>
            <div className='cards__items'>
            <CardItemModel
              src='images/BAM 32/BAM 32 (1).jpg'
              text='TWO STORY HOUSE'
              price='LKR 9.5 Million'
              label='BAM 32'
              description='4 Bedrooms,2 Bathroom'
              path='/bam32'
            />
             </div>
             <div className='cards__items'>
            <CardItemModel
              src='images/BAM 33/BAM 33 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 33'
              price='LKR 12.5 Million'
              path='/bam33'
              description='4 Bedrooms,2 Bathroom'
            />
           </div>
           
             </div>


             <div className='cards__container'>
             <div className='cards__items'>
            <CardItemModel
              src='images/BAM 34/BAM 34 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 34'
              price='LKR 12 Million'
              path='/bam34'
              description='3 Bedrooms,2 Bathroom'
            />
             </div>
             
             <div className='cards__items'>
            <CardItemModel
              src='images/BAM 35/BAM 35 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 35'
              price='LKR 13 Million'
              path='/bam35'
              description='4 Bedrooms,2 Bathroom'
            />
             </div>
             <div className='cards__items'>
            <CardItemModel
              src='images/BAM 36/BAM 36 (1).jpg'
              text='TWO STORY HOUSE'
              label='BAM 37'
              price='LKR 13.5 Million'
              path='/bam36'
              description='4 Bedrooms,2 Bathroom'
            />
          </div>
        </div> 
    </div>
  );
}

export default Model;
